import { Injectable } from '@angular/core';
import {GeneralServices} from '../../../../services/general-services';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ProjectConstants} from '../../../project-constants';
import {ContractSettingsModel} from '../../../../models/ContractSettingsModel';
import {Observable} from 'rxjs';
import {map, take} from 'rxjs/operators';
import * as servers from '../../../../services/api/servers';
import {urls} from '../../../../services/api/urls';

@Injectable({
  providedIn: 'root'
})
export class ContractTypeSettingsService extends ProjectConstants implements GeneralServices {

  header: any;
  // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.contractSetting;
  baseUrl: string = servers.apiUrl + urls.contractSetting;
  constructor(private http: HttpClient) {
    super();

    this.header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    };
  }

  delete(url: string, id: number): Observable<any> {
    url = url + '/' + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }

  getAll(url: string, filters: any, payload?: any): Observable<any> {
    url = url + this.LINKS.PAGE;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
      .pipe(
        map (data => data)
      );
  }

  getPage(filters: any, payload?: any): Observable<any> {
    const url = this.baseUrl + this.LINKS.PAGE;
    const body =  payload ? JSON.stringify(payload) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: filters})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getById(url: string) {
  }

  save(url: string, object: any) {
    const body =  object ? JSON.stringify(object) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  update(url: string, object: any) {
    const body =  object ? JSON.stringify(object) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.put( url, body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  softDelete(id: number): Observable<any> {
    const url = this.baseUrl  + this.LINKS.SOFT_DELETE + id;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.delete(url, {headers: header, responseType: 'json'})
      .pipe(
        map (data => data)
      );
  }
}
